module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-1668x2224.3c6a01a8.png";